import SANGJO_PRODUCTS from "@/constants/grouped_sangjo_products.json";
import { useMemo } from "react";

interface UseTotalPriceProps {
  sangjoId: string;
  sangjoProductId: number;
  paymentsCount: number;
}

export const useRefundSangjoTotalPrice = ({
  sangjoId,
  sangjoProductId,
  paymentsCount,
}: UseTotalPriceProps) => {
  const sangjoProducts = sangjoId ? SANGJO_PRODUCTS[sangjoId as keyof typeof SANGJO_PRODUCTS] : [];

  const selectedSangjoProduct = sangjoProducts
    ? sangjoProducts.find((product) => product.id === Number(sangjoProductId))
    : undefined;

  const productUserTotalPrice = useMemo(() => {
    if (selectedSangjoProduct?.paymentType === "정기형") {
      const productTotalPrice =
        Number(selectedSangjoProduct?.monthPaymentPrice.replaceAll(",", "")) * paymentsCount;

      return productTotalPrice;
    }

    if (selectedSangjoProduct?.paymentType === "비정기형") {
      const 납입기간배열 = selectedSangjoProduct.비정기_납입기간.split("+");
      const 납입금액배열 = selectedSangjoProduct.비정기_납입금액.split("+");

      const 납입기간가격리스트 = 납입기간배열.reduce((acc, cur, index) => {
        const newAcc = Array.from({ length: Number(cur) }, () => Number(납입금액배열[index]));

        return [...acc, ...newAcc];
      }, [] as number[]);

      const 총_납입금액 = 납입기간가격리스트
        .splice(0, paymentsCount)
        .reduce((acc, cur) => acc + cur, 0);

      return 총_납입금액;
    }
  }, [paymentsCount]);

  const productTotalPrice = useMemo(() => {
    if (selectedSangjoProduct?.paymentType === "정기형") {
      const productTotalPrice =
        Number(selectedSangjoProduct?.monthPaymentPrice.replaceAll(",", "")) *
        Number(selectedSangjoProduct?.totalPaymentDates);

      return productTotalPrice;
    }

    if (selectedSangjoProduct?.paymentType === "비정기형") {
      const 납입기간배열 = selectedSangjoProduct.비정기_납입기간.split("+");
      const 납입금액배열 = selectedSangjoProduct.비정기_납입금액.split("+");

      const 납입기간가격리스트 = 납입기간배열.reduce((acc, cur, index) => {
        const newAcc = Array.from({ length: Number(cur) }, () => Number(납입금액배열[index]));

        return [...acc, ...newAcc];
      }, [] as number[]);

      const 총_납입금액 = 납입기간가격리스트.reduce((acc, cur) => acc + cur, 0);

      return 총_납입금액;
    }
  }, [sangjoProductId]);

  return {
    productUserTotalPrice,
    productTotalPrice,
  };
};
